<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18.001" height="18.034" viewBox="0 0 18.001 18.034">
    <path class="a"
          d="M18.111,14v2.413a1.609,1.609,0,0,1-1.754,1.609,15.921,15.921,0,0,1-6.943-2.47,15.687,15.687,0,0,1-4.827-4.827,15.921,15.921,0,0,1-2.47-6.975A1.609,1.609,0,0,1,3.719,2H6.133A1.609,1.609,0,0,1,7.742,3.384,10.329,10.329,0,0,0,8.3,5.644a1.609,1.609,0,0,1-.362,1.7L6.921,8.363a12.872,12.872,0,0,0,4.827,4.827l1.022-1.022a1.609,1.609,0,0,1,1.7-.362,10.329,10.329,0,0,0,2.261.563A1.609,1.609,0,0,1,18.111,14Z"
          transform="translate(-1.111 -1)"/>
  </svg>
</template>

<script>
export default {
  name: "PhoneIcon"
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #8bcbb7;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
